import { Stack, usePathname } from 'expo-router';
import React from 'react';
import { useStyles } from 'react-native-unistyles';

import BackButton from '@/components/back-button';

export default function SearchDetailsLayout() {
  const { theme } = useStyles();
  const pathname = usePathname();

  return (
    <Stack
      screenOptions={{
        headerShown: pathname === '/search-details',
        headerTitle: 'Search For Your Next Ride',
        headerTitleAlign: 'center',
        headerStyle: {
          backgroundColor: theme.colors.background_1,
        },
        headerTintColor: theme.colors.text.primary,
        headerShadowVisible: false,
        headerLeft: () => <BackButton />,
      }}
    />
  );
}
